import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, TextField, Paper, withStyles, Button, FormHelperText, Select, MenuItem } from '@material-ui/core';
import PageTitle from '../../../components/PageTitle/PageTitle';
import FormInputLabel from '../../../components/FormInputLabelView';
import Loader from '../../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../../utils/common';

class RoomsBedsPage extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    // this.initData = this.initData;
    this.state = {
      data: {
        room: '',
        bed: '',
        roomType: '',
        bedType: '',
        subGroupId: '',
      },
      errorField: {
        room: false,
        bed: false,
      },
    };
  }
  async componentDidMount() {
    await this.props.bed.getRoomType();
    await this.props.bed.getBedType();

    this.initData();
  }
  goBack() {
    this.props.bed.setAction('action', true);
    this.props.history.goBack();
  }

  initData() {
    const { bedsList } = this.props.bed.toJS();
    const { idbed } = this.props.match.params; // id bed
    const idBed = Number(idbed);
    const showData = bedsList.data.find((item) => item.id === idBed);
    if (showData) {
      this.setState({
        data: {
          id: showData.id,
          room: showData.roomName,
          bed: showData.name,
          roomType: showData.roomTypeId,
          bedType: showData.bedTypeId,
          subGroupId: showData.subGroupId,
        },
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
  };

  handleCreateBed = async () => {
    const { t } = this.props;
    const modulePath = this.props.location.pathname.replace('/app/modules/', '');
    const moduleId = Number(modulePath.replace('/manage/create', ''));
    if (this.validate()) {
      try {
        const result = await this.props.bed.createBed(this.state.data, moduleId);
        if (result.statusCode === 200) {
          Swal.fire({ html: `<h4>${t('create_success')}`, type: 'success' }).then(async (resultSuccess) => {
            if (resultSuccess.value) {
              // await this.props.bed.getBedsList(moduleId);
              this.props.history.push(`../../${moduleId}/manage`);
            } else {
              Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
            }
          });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
      }
    }
  };

  handleEditBed = async (data) => {
    const { t } = this.props;
    const moduleId = this.props.match.params.id;
    // const modulePath = this.props.location.pathname.replace('/app/modules/', '')
    // const moduleId = Number(modulePath.replace('/bed/create', ''))
    if (this.validate()) {
      Swal.fire({
        html: `<h4>${t('edit_room_bed')}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${t('edit')}`,
        cancelButtonText: `${t('cancel')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          try {
            const result = await this.props.bed.updateBed(data);
            if (result.statusCode === 200) {
              Swal.fire({ html: `<h4>${t('update_success')}`, type: 'success' }).then(async (resultSuccess) => {
                if (resultSuccess.value) {
                  this.props.bed.setAction('action', true);
                  this.props.history.push(`../../../${moduleId}/manage`);
                } else {
                  Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
                }
              });
            }
          } catch (e) {
            if (e.statusCode === 401) {
              clearLocalStorage();
              window.location.href = '/login';
            } else {
              Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
            }
          }
        }
      });
      // try {
      //   await this.props.bed.updateBed(data)
      // } catch (e) {
      // }
    }
  };

  validate() {
    const { data } = this.state;
    if (!data.room) {
      let checkRoom = !data.room ? true : false;
      this.setState({
        errorField: {
          room: checkRoom,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          room: false,
        },
      });
    }
    return true;
  }

  clearErrorField(key) {
    if (key === 'room') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          room: false,
        },
      });
    }
    // if (key === 'bed') {
    //   this.setState({
    //     ...this.state,
    //     errorField: {
    //       ...this.state.errorField,
    //       bed: false
    //     }
    //   })
    // }
  }

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data } = this.state;
    const { roomType, bedType, loading } = this.props.bed.toJS();
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_room_bed')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('room_name')} required />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                id='room'
                name='room'
                fullWidth
                value={data.room}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.room : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.room : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('room_type')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.roomType || 0}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'roomType',
                    id: 'roomType',
                  }}
                >
                  <MenuItem fullwidth='true' key={0} value={0}>
                    {t('please_select_room_type')}
                  </MenuItem>
                  {(roomType || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('bed_name')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id='bed'
                name='bed'
                fullWidth
                value={data.bed}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                // error={!data.reset ? this.state.errorField.bed : false}
              />
              {/* <FormHelperText
                    error
                    hidden={!data.reset ? !this.state.errorField.bed : true}
                    id="  component-error-text"
                  >
                    This is a required filed.
                  </FormHelperText> */}
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('bed_type')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.bedType || 0}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'bedType',
                    id: 'bedType',
                  }}
                >
                  <MenuItem fullwidth='true' key={0} value={0}>
                    {t('please_select_bed_type')}
                  </MenuItem>
                  {(bedType || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleCreateBed(data)}
                  className={classes.button}
                >
                  {t('create')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data } = this.state;
    const { roomType, bedType, loading } = this.props.bed.toJS();
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_room_bed')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('room_name')} required />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                id='room'
                name='room'
                fullWidth
                value={data.room}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.room : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.room : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('room_type')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.roomType || 0}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'roomType',
                    id: 'roomType',
                  }}
                >
                  <MenuItem fullwidth='true' key={0} value={0}>
                    {t('please_select_room_type')}
                  </MenuItem>
                  {(roomType || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('bed_name')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id='bed'
                name='bed'
                fullWidth
                value={data.bed}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                // error={!data.reset ? this.state.errorField.bed : false}
              />
              {/* <FormHelperText
                    error
                    hidden={!data.reset ? !this.state.errorField.bed : true}
                    id="  component-error-text"
                  >
                    This is a required filed.
                  </FormHelperText> */}
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('bed_type')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.bedType || 0}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'bedType',
                    id: 'bedType',
                  }}
                >
                  <MenuItem fullwidth='true' key={0} value={0}>
                    {t('please_select_bed_type')}
                  </MenuItem>
                  {(bedType || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleEditBed(data)}
                  className={classes.button}
                >
                  {t('edit')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    const { roomType, bedType, bedsList, loading } = this.props.bed.toJS();
    const { idbed } = this.props.match.params; // id bed
    const idBed = Number(idbed);
    const showData = bedsList.data.find((item) => item.id === idBed);

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_room_bed')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('room_name')} required />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                required
                id='room'
                name='room'
                fullWidth
                value={showData.roomName}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('room_type')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={showData.roomTypeId || 0}
                  inputProps={{
                    name: 'roomTypeId',
                    id: 'roomTypeId',
                  }}
                  disabled
                >
                  <MenuItem fullwidth='true' key={0} value={0}>
                    {t('please_select_room_type')}
                  </MenuItem>
                  {(roomType || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('bed_name')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id='bed'
                name='bed'
                fullWidth
                value={showData.name}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('bed_type')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={showData.bedTypeId || 0}
                  inputProps={{
                    name: 'bedType',
                    id: 'bedType',
                  }}
                  disabled
                >
                  <MenuItem fullwidth='true' key={0} value={0}>
                    {t('please_select_bed_type')}
                  </MenuItem>
                  {(bedType || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/modules/:id/bed/:idbed/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  spaceTop: {
    marginTop: '10px',
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  TitlePage: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 4,
    background: '#049588',
    height: '90px',
    margin: '-24px',
  },
  typo: {
    color: 'white',
    padding: '30px',
  },
});
export const page = inject('subGroup', 'group', 'bed', 'maps')(observer(RoomsBedsPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
